import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import {  getClaimRelatedPeopleClaimantClaims } from "../api/ClaimAPI";
import { RootState } from "../../../redux/store";
import { PaginationFilterDto } from "../../../types/Pagination";
import { useQuery } from "@tanstack/react-query";

type QueryFnType = typeof getClaimRelatedPeopleClaimantClaims;

type UseGetClaimsForClaimant = {
    config?: QueryConfig<QueryFnType>;
};

export const useGetClaimsForClaimant = ({ config }: UseGetClaimsForClaimant = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.claimsForPersonByClaimantClaims.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.claimsForPersonByClaimantClaims);
    const filterByOnlyActiveRecords = useSelector((state: RootState) => state.filters.claimsForPersonByClaimantClaims.filterByOnlyActiveRecords);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByOnlyActiveRecords: filterByOnlyActiveRecords,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: []
    };

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getClaimRelatedPeopleClaimantClaims', selectedFilters, pagination, filterByOnlyActiveRecords],
        enabled: selectedFilters?.some(
            x => x.values && x.values.some(v => v.trim() !== "")
        ),
        queryFn: () => getClaimRelatedPeopleClaimantClaims(paginationFilters),
    });
}
